import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=63c89129&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=63c89129&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c89129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c89129')) {
      api.createRecord('63c89129', component.options)
    } else {
      api.reload('63c89129', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=63c89129&scoped=true", function () {
      api.rerender('63c89129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/TuitionStatistics/layout.vue"
export default component.exports